import { Link } from "@tanstack/react-router";
import { ChevronRight } from "lucide-react";
import React from "react";

import type { ResourceSelect } from "../../../drizzle/schema";

import { Button } from "./button";
import { Card, CardContent, CardDescription, CardTitle } from "./card";
import { CDNImage } from "./cdn-image";

interface ResourceCardProps {
  resource: Pick<ResourceSelect, "id" | "title" | "description" | "imageSrc">;
  coachUsername: string;
  className?: string;
}

/** Card for a resource a coach shares. */
export const ResourceCard = ({
  resource,
  coachUsername,
  className,
}: ResourceCardProps) => {
  return (
    <Link
      to="/$username/resources/$resourceId"
      params={{ username: coachUsername, resourceId: resource.id }}
    >
      <Card className={className} variant="interactive">
        <CardContent className="flex h-full flex-col gap-2">
          {resource.imageSrc ? (
            <CDNImage
              src={resource.imageSrc}
              alt={resource.title}
              width={384}
              height={202}
              className="mb-4 aspect-[40/21] h-48 w-full rounded-lg object-cover"
            />
          ) : (
            <div className="mb-4 aspect-[40/21] w-full rounded-lg bg-gray-200" />
          )}
          <CardTitle>{resource.title}</CardTitle>
          <CardDescription className="grow-1">
            {resource.description}
          </CardDescription>
          <Button className="mt-2">
            Read more <ChevronRight />
          </Button>
        </CardContent>
      </Card>
    </Link>
  );
};
